module.exports = __webpack_public_path__ + "img/adult-chukka-green_2.14db6d74.jpg";